import React, { useEffect, useState, useRef } from "react";
import HeaderComponent from "../header";
import GetInTouchComponent from "../getInTouch";
import FooterComponent from "../footer";
import { useNavigate, useParams } from "react-router-dom";

import "../../styles/ourServices/services.scss";
import { ourServices } from "./ourServicesContent";

const SelectedServicesComponent = () => {
  const navigate = useNavigate();
  const { serviceName } = useParams();

  const refs = {
    Home: useRef(null),
    Services: useRef(null),
    "Case Studies": useRef(null),
    Blog: useRef(null),
    Contact: useRef(null),
    About: useRef(null),
  };

  const handleScrollToPortion = (section) => {
    if (section === "Contact") {
      refs[section]?.current?.scrollIntoView({ behavior: "smooth" });
    } else if (section === "About") {
      navigate(`/aboutUs`);
    } else {
      navigate("/", { state: { scrollTo: section } });
    }
  };

  return (
    <div className="selected-service">
      <HeaderComponent
        handleScrollToPortion={handleScrollToPortion}
        // headerName={'WizzGeeks'}
      />
      {ourServices?.map((data) => {
        return (
          data.name === serviceName && (
            <div className="our-selected-service-wrapper">
              <div className="our-selected-card-services-wrapper">
                <div
                  className="service-back-wrapper cursor-pointer"
                  onClick={() => {
                    navigate("/", { state: { scrollTo: "Services" } });
                  }}
                >
                  <img src="../../images/ourServices/leftArrow.svg"></img>
                  <p>Back to Services</p>
                </div>
                <img className="selected-service-img" src={data?.image}></img>
                <div className="selected-service-heading-name">
                  {data?.name}
                </div>
                <div className="selected-service-short-description">
                  {data?.shortDescription}
                </div>
              </div>
              <div className="our-selected-card-content-service-wrapper">
                <div className="selected-service-long-description">
                  {data?.longDescription}
                </div>
                <div className="selected-service-who-service-for">
                  <span>Who This Service Is For</span>
                  {data?.whoServiceFor}
                </div>
                <div className="selected-service-benefits-points">
                  <div className="selected-service-benefits">Benefits</div>
                  {data?.benefits?.map((data) => {
                    return (
                      <div className="benefits-points-wrapper">
                        <img src="../../images/ourServices/pointsIcon.svg"></img>
                        {data}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          )
        );
      })}
      <GetInTouchComponent
        headerName={"Ready to Get Started?"}
        subHeaderName={
          "Contact us today to discuss how our Brand Strategy service can help your business grow"
        }
        ref={refs.Contact}
      />
      <FooterComponent />
    </div>
  );
};

export default SelectedServicesComponent;
